module.exports = __webpack_public_path__ + "static/media/wma.f198ff9d.png";